import Homepage from "../components/Homepage"
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <>
            <Navbar />
            <Homepage />
            <br/>
            <br/>
            <Footer/>
        </>
    )
}